import { FC } from "react"
import { useInvitedEvents } from "../../../shared/user-profile/hooks"
import ProfileEventCard from "../profile_event_card"
import LocationSpinner from "@/common/ui-kit/spinner"

const InvitedEventList: FC = () => {
  const { isLoading, error, state } = useInvitedEvents()
  if (isLoading)
    return (
      <div
        style={{
          minWidth: "calc(100vw - 16px)",
          textAlign: "center",
          padding: "48px 0",
        }}
      >
        <LocationSpinner />
      </div>
    )
  if (error) return <div>{error.error}</div>

  return (
    <>
      {state?.length === 0 ? (
        <div
          style={{
            minWidth: "calc(100vw - 16px)",
            textAlign: "center",
            padding: "48px 0",
            color: "var(--Schemes-Primary)",
          }}
        >
          Вас пока никуда не пригласили
        </div>
      ) : (
        state?.map((event) => <ProfileEventCard info={event} key={event.id} />)
      )}
    </>
  )
}

export default InvitedEventList
